import {
    GET_CONTACT_SUPPORT_LIST_ACTION,
    CREATE_CONTACT_SUPPORT_REQUEST_ACTION,
    ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ACTION
} from "./types"

export const getContactSupportListAction = (data) => ({
    type: GET_CONTACT_SUPPORT_LIST_ACTION,
    payload: data
})

export const createContactSupporRequestAction = (data) => ({
    type: CREATE_CONTACT_SUPPORT_REQUEST_ACTION,
    payload: data
})

export const addContactSupportRequestResponseAction = (id, data) => ({
    type: ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ACTION,
    payload: data,
    contact_id: id // The contact Support Request ID
})